module.exports = __webpack_public_path__ + "img/home-help.de8cb831.svg";